<template lang="pug">
  .wrapper-progression-bar
    span.progression(:style="{width: percentage+'%'}")
</template>

<script type="text/javascript">
import { QUESTION_TIME } from "@/service/constants";

export default {
  name: "ProgressionBar",
  components: {},
  props: ["remainingSeconds"],
  data() {
    return {
      percentage: 100,
    };
  },
  watch: {
    remainingSeconds: function (newValue) {
      const remaining = parseInt(this.remainingSeconds, 10);
      const percentage = parseInt(100 * (remaining / QUESTION_TIME), 10);
      this.percentage = percentage;
    },
  },
};
</script>
